// @ts-nocheck
/* eslint-enable */
// App
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

// Components

// Misc / utils
import { filterUtils_getNumberOfActiveFilters } from 'app/shared/utils/filterUtils';
import * as S from './styles';

const AllFiltersButtonBase = ({ ariaLabel, ariaExpanded, icon, iconWidth, iconHeight, onClick, customRef }) => {
  // Redux
  const filter = useSelector((state) => state.filter);
  const screenWidth = useSelector((state) => state.app.device.screenWidth);

  // React
  const [numActiveFilters, setNumActiveFilters] = useState(null);

  useEffect(() => {
    let excludeFilters = ['commute'];
    if (screenWidth === 'sm' || screenWidth === 'lg' || screenWidth === 'xl') {
      excludeFilters = [].concat(excludeFilters, ['price', 'bedrooms', 'pets', 'bathrooms']);
    }
    const num = filterUtils_getNumberOfActiveFilters(filter, excludeFilters);
    setNumActiveFilters(num);
  }, [filter]);

  return (
    <S.ButtonContainer
      ariaLabel={ariaLabel}
      ariaExpanded={ariaExpanded}
      active={numActiveFilters > 0}
      icon={numActiveFilters > 0 ? null : icon}
      iconWidth={iconWidth}
      iconHeight={iconHeight}
      onClick={onClick}
      ref={customRef}
    >
      {numActiveFilters > 0 && <S.NumFilterBadge>{numActiveFilters}</S.NumFilterBadge>}
      All filters
    </S.ButtonContainer>
  );
};

export default AllFiltersButtonBase;
